import type { ReactNode } from 'react'

import Skeleton from '@mui/material/Skeleton'
import clsx from 'clsx'
import { campaignApi } from 'features/campaigns'
import { Link } from 'react-router-dom'
import { typo } from 'shared/styles'
import { StackIcon } from 'shared/ui'

import css from './Name.module.css'

const iconFolder = (
	<StackIcon
		className={css.icon}
		icon='folder'
		key='i'
		stack='execution'
		width={14}
	/>
)

const skeletonTitle = <Skeleton key='💀' variant='text' width={'20ch'} />

const wrapperCN = clsx(css.wrapper, typo.buttonSmB)

export function Name({ id = '', noData }: { id?: string; noData?: boolean }) {
	const { data, isSuccess } = campaignApi.useGetCampaignsByIdQuery(id, {
		skip: !id
	})

	const children: ReactNode[] = [iconFolder]

	if (id) {
		const isReady = id && isSuccess && data.id === id

		children.push(
			isReady ? (
				<span className={css.text} key='t'>
					{data.name}
				</span>
			) : (
				skeletonTitle
			)
		)

		return (
			<Link className={wrapperCN} to={`/campaigns/${id}`}>
				{children}
			</Link>
		)
	}

	children.push(
		noData ? (
			<span className={css.text} key='t'>
				No campaign
			</span>
		) : (
			skeletonTitle
		)
	)

	return <h2 className={wrapperCN}>{children}</h2>
}
